// Date-only DB columns (dueDate, signedAt, weddingDate, etc.) are stored as
// UTC-midnight timestamps. Format them in UTC so the displayed date matches the
// stored date regardless of the viewer's timezone — otherwise PST viewers see
// the day before.
export function formatDateUTC(
  iso: string | Date | null | undefined,
  opts: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' },
): string {
  if (!iso) return '—';
  const date = iso instanceof Date ? iso : new Date(iso);
  return new Intl.DateTimeFormat('en-US', { ...opts, timeZone: 'UTC' }).format(date);
}
